import { getPACSFromSessionStorage } from "./Utils/localPACSutils";

const LocalpacsInfo = getPACSFromSessionStorage('LOCAL_PACS_INFO')

export const baseURL = "https://backend.phoenixplus.io"
 //export const baseURL="http://localhost:5985"
 export const aiBaseURL="http://localhost:8001"


// Remote PACS Configuration
export const PACS_URL = 'https://pacs.phoenixplus.io'
export const AET = `DCM4CHEE`
export const graceperiod = -7;

// Local PACS Configuration
//export const LOCAL_PACS_URL = `http://${LocalpacsInfo ? LocalpacsInfo[0]?.ipAddress : 'localhost'}:${LocalpacsInfo ? LocalpacsInfo[0]?.port : 8081}`
export const LOCAL_PACS_URL = `${LocalpacsInfo ? LocalpacsInfo[0]?.localPacsAddress : 'https://localhost:8081'}`
export const LOCAL_PACS_AET = `${LocalpacsInfo ? LocalpacsInfo[0]?.aeTitle : 'DCM4CHEE'}`
// export const LOCAL_PACS_AET = `${LocalpacsInfo ? 'DCM4CHEE': 'DCM4CHEE'}`

export const frontendBaseURl = 'https://phoenixplus.io/';
export const AUTH_TOKEN_KEY = 'token';

export interface initialState {
  status: string;
  result: any;
  msg: string;
  loading: boolean;
  error: string | null;
}

export const initialState: initialState = {
  status: "",
  result: null,
  msg: "",
  loading: false,
  error: null,
};

export const LOGIN_API_URL = `${baseURL}/login`;
export const FORGOTPASSWORD_API_URL = `${baseURL}/user/forgotpassword`;
export const VERIFYEMAIL_API_URL = `${baseURL}/user/verifyverificationcode`;
export const RESETPASSWORD_API_URL = `${baseURL}/user/setpassword`;
export const GETUSERDETAIL_API_URL = `${baseURL}/user/detail`;
export const CHANGEPASSWORD_API_URL = `${baseURL}/user/changepasswordfromprofile`;
export const UPDATEPROFILE_API_URL = `${baseURL}/user/updateprofile`;
export const KC_DCM_TOKEN_URL = ` https://keycloak.phoenixplus.io/realms/dcm4che/protocol/openid-connect/token`;
export const KC_CLIENT_ID = 'seven-hills';
export const KC_CLIENT_SECRET = 'TsyAfixnzmRagX0zy6UXY5VUZ16n0PKj';
// export const KC_CLIENT_SECRET = 'dSATZwXpEL9TPeLLqHUtRcSW4w2YjMki';
export const KC_GRANT_TYPE = 'client_credentials';
// export const LOCAL_KC_DCM_TOKEN_URL = `https://localhost:8843/realms/dcm4che/protocol/openid-connect/token`;
export const LOCAL_KC_DCM_TOKEN_URL_UNCHANGED_PART = '/realms/dcm4che/protocol/openid-connect/token';
// export const LOCAL_KC_CLIENT_ID = 'seven-hills-local';
// export const LOCAL_KC_CLIENT_SECRET = '6dzueqtPXDgm21nQ2TILS3gpjH2Inziv';

export const CREATEUSER_API_URL = `${baseURL}/createUser`;


// Patients
export const GET_ALL_PATIENT_API_URL = `${baseURL}/getAllPatients`;
export const GET_PATIENT_DETAIL_API_URL = `${baseURL}/patient/detail`;

//previousappointment
export const GET_PREVIOUSAPPOINTMENT_DETAIL_API_URL = `${baseURL}/patient/previousappointment`;



//Reports
export const CREATE_REPORT_TEMPLATE = `${baseURL}/createReportTemplate`
export const GET_ALL_REPORT_TEMPLATES = `${baseURL}/getReportTemplates`
export const DELETE_REPORT_TEMPLATE = `${baseURL}/deleteReportTemplate`
export const EDIT_REPORT_TEMPLATE = `${baseURL}/updateTemplate`

export const CREATE_REPORT = `${baseURL}/createReport`;
export const GET_CURRENT_PATIENT_REPORT = `${baseURL}/getCurrentReport`;

export const GET_ROLLBACK_DETAIL_REPORT = `${baseURL}/rollbackreport/detail`

// Studylist
export const FILTER_PATIENT_STUDIES = `${baseURL}/getStudies`

//Report List

export const GET_ALL_REPORTS = `${baseURL}/getReports`

//update report

export const UPDATE_REPORT = `${baseURL}/updateReport`
export const UPDATED_REPORT_DATA = `${baseURL}/updatereportdata`

// Hospital

export const CREATE_HOSPITAL = `${baseURL}/addhospital`
export const HOSPITAL_LIST = `${baseURL}/gethospitallist`
export const UPDATE_HOSPITAL_DETAIL = `${baseURL}/updatehospitaldata`
export const DELETE_HOSPITAL = `${baseURL}/deletehospital`
export const GET_HOSPITAL_DETAIL = `${baseURL}/hospital/detail`

// User

export const CREATE_USER = `${baseURL}/user/add`
export const GET_USERLIST = `${baseURL}/user/getuserlist`

// User

export const CREATE_TELERADIOLOGY_USER = `${baseURL}/teraradiology/adduser`
export const GET_TELERADIOLOGY_USERLIST = `${baseURL}/user/getuserlist`

//Common

export const COMMON_DATA_LIST = `${baseURL}/common/data`
export const STATE_COUNTRY_LIST = `${baseURL}/common/statecity`

//Rollback
export const ROLLBACK_API_URL = `${baseURL}/report/rollback`;
export const ROLLBACK_LIST_API_URL = `${baseURL}/rollbackreport/list`;


//activemachinelist
export const ACTIVEMACHINELIST = `${baseURL}/machine/activemachinelist`;
export const ADD_ACTIVEMACHINE = `${baseURL}/machine/addactivemachine`;
export const DELETEACTIVE_MACHINES = `${baseURL}/machine/delete`


//teleraidology customer
export const TELERADIOLOGY_LIST_API_URL = `${baseURL}/teraradiology/list`;
export const TELERADIOLOGY_ADD_API_URL = `${baseURL}/teraradiology/add`;


//review
export const GET_RAIDOLOGIEST_DATA = `${baseURL}/user/fetchradiologistuser`
export const GET_RADIOLOGIST_LIST = `${baseURL}/user/fetchHospitalRadiologists`
export const SEND_REVIEW_DATA = `${baseURL}/report/sendreview`
export const GET_REVIEW_DATA = `${baseURL}/report/reviewlist`
export const SEND_BACK_REPORT = `${baseURL}/report/sendback`

//pathology
export const GET_PATHOLOGIEST_DATA = `${baseURL}/user/fetchPathologistUser`
export const ASSIGN_PATHOLOGIST_TO_WSI = `${baseURL}/patient/assignPathologistToWSI`
export const ASSIGN_TO_SUPERADMIN = `${baseURL}/patient/assignSuperAdminToWSI`;


//REPORTS
export const GET_REPORTS_DATA = `${baseURL}/getReports`
export const SHARE_REPORT_WHATSAPP = `${baseURL}/report/share`
export const GET_SHARED_DETAIL_REPORT = `${baseURL}/common/sharereport`
export const CHANGE_REPORT_PRIORITY = `${baseURL}/report/changeReportPriority`
export const DELETE_PREVIEW_IMAGE = `${baseURL}/report/delete-image`

// Patient Graph api end point

export const GET_MODALITY_WISE_PATIENT_DATA = `${baseURL}/patient/modalityWisePatientData`
export const GET_MONTHLY_PATIENT_DATA = `${baseURL}/patient/monthlyPatientData`
export const VERIFY_REPORT = `${baseURL}/verifyReport`;
export const VERIFY_TELEPATHOLOGY_REPORT = `${baseURL}/verifyPathologyReport`;


//Microscopy
export const UPLOAD_IMAGE_MICROSCOPY = `${baseURL}/microscopy/uploadSeries`
export const GET_PATIENT_MICROSCOPIC_LINK = `${baseURL}/microscopy/getPatientMicroscopicLink`
export const SAVE_MICROSCOPY_MEASUREMENTS = `${baseURL}/annotation/addAnnotation`
export const GET_MICROSCOPY_MEASUREMENTS = `${baseURL}/annotation/getAnnotationsByWSIId`
export const UPDATE_MICROSCOPY_MEASUREMENTS = `${baseURL}/annotation/updateAnnotation`
export const DELETE_MICROSCOPY_ANNOTATIONS = `${baseURL}/annotation/deleteAnnotation`
export const UPLOAD_VIDEO_MICROSCOPY = `${baseURL}/microscopy/savePatientMicroscopicVideoLink`

//Settings
export const UPDATE_TOGGLE_SETTINGS_API_URL = `${baseURL}/user/addToolSettings`


export const SHARE_PATIENT_REPORT_LINK = `${baseURL}/report/shareReportLink`
export const GET_REFER_PHYSCIAN_INFO = `${baseURL}/report/getReferPhysicianInfo`

// Abha endpoints
export const SEND_ABHA_OTP = `${baseURL}/abha/sendOTP`
export const VERIFY_ABHA_OTP = `${baseURL}/abha/verifyOTP`
export const ENROLL_ABHA_VIA_AADHAAR = `${baseURL}/abha/enrollABHAViaAadhaar`
export const VERIFY_OTP = `${baseURL}/abha/verifyOTPAndEnroll`

//Referring Doctor
export const GET_REFERRING_DOCTORS = `${baseURL}/analytics/fetchReferringDoctors`
export const ADD_REFERRING_DOCTOR = `${baseURL}/analytics/addReferingDoctor`

//Analytics
export const GET_PATIENT_ANALYTICS = `${baseURL}/analytics/getPatientAnalytics`
export const GET_REPORT_ANALYTICS = `${baseURL}/analytics/getReportAnalytics`
export const GET_APPOINTMENT_ANALYTICS = `${baseURL}/analytics/getAppointmentAnalytics`
export const GET_TURN_AROUND_TIME = `${baseURL}/analytics/getReportAnalyticsTAT`
export const GET_PEER_REVIEW = `${baseURL}/analytics/noOfPeerReviewedCases`
export const GET_ROLLBACK_ERROR_TRACKING = `${baseURL}/analytics/rollbackErrorTracking`
export const GET_RADIOLOGIST_PERFORMANCE = `${baseURL}/analytics/radiologistPerformance`
export const GET_CALC_AVG_REPORT_TIME = `${baseURL}/analytics/calculateAverageReportingTime`
export const GET_STRAT_N_BUSS_METRIX = `${baseURL}/analytics/strategicAndBusinessMetrics`
export const GET_RADIOLOGIST_CASE_RATIO = `${baseURL}/analytics/radiologistCaseRatio`
export const GET_RADIOLOGIST_DASHBOARD = `${baseURL}/analytics/radiologistAnalyticDashboard`

// Lab Studies
export const GET_LAB_STUDIES = `${baseURL}/patient/labPatient`

// Quality Indicators
export const GET_QUALITY_INDICATORS = `${baseURL}/indicators/indicatorsData`

//Cancel Study
export const CANCEL_STUDY = `${baseURL}/cancelStudy`;
export const GET_CANCELLED_STUDIES = `${baseURL}/getCanceledStudies`;

export const caseTiming = `${baseURL}/settings/case-timing`;
export const STUDY_LAB_ACCEPTANCE_STATUS = `${baseURL}/patient/changeLabStudyStatus`

export const AI_STUDY = `${baseURL}/ai-studies/aiResults`;
export const UPDATE_AI_STUDY = `${baseURL}/ai-studies/updateAIData`;
export const GET_PATHOLOGY_AI_STUDIES = `${baseURL}/ai-studies/pathologyAIStudies`;
export const RETRIGGER_PATHOLOGY_AI = `${baseURL}/ai-studies/retriggerPathologyAI`;
export const PATHOLOGY_AI_RESULTS = `${baseURL}/ai-studies/pathologyAIResults`;
